export const sendContactDetails = "SEND_CONTACT_DETAILS"
export const getContactDetails  = "GET_CONTACT_DETAILS"



